export const ADD_SELECTED_STATE = "ADD_SELECTED_STATE";

// master code
export const MASTER_CODE_REQUEST = "MASTER_CODE_REQUEST";
export const LOGOUT = "LOGOUT";

// map click action
export const FETCH_ALL_MARKERS_ON_MAP = "FETCH_ALL_MARKERS_ON_MAP"; 
export const CLICKED_MARKER_ON_MAP = "CLICKED_MARKER_ON_MAP";
export const POINTER_ON_MAP = "POINTER_ON_MAP"; // pointer when we click on map action
export const MAP_ACTION_LOADING = "MAP_ACTION_LOADING";